import { render, staticRenderFns } from "./SupervisorIntro.vue?vue&type=template&id=788495a6"
import script from "./SupervisorIntro.vue?vue&type=script&lang=js"
export * from "./SupervisorIntro.vue?vue&type=script&lang=js"
import style0 from "./SupervisorIntro.vue?vue&type=style&index=0&id=788495a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports